import {Box, Typography} from '@mui/material';
import {AurInfographicCellProps} from './types';
import styles from './style.module.scss';
import {ReactComponent as InfoIcon} from '../../../assests/svg/info_icon_outlined_blue.svg';
import AurTooltip from '../aur-tooltip/AurTooltip';

const AurInfographicCell = (props: AurInfographicCellProps) => {
  const {
    primaryText,
    secondaryText,
    className = '',
    ariaLebel = '',
    showInfoIcon = false,
    infoToolTipMsg,
    infoToolTipTestId,
  } = props;

  const renderInfo = () => {
    if (infoToolTipMsg) {
      return (
        <AurTooltip
          title={infoToolTipMsg}
          aria-label={infoToolTipMsg}
          className="typo-text body4_size tooltip-content"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -7],
                  },
                },
              ],
            },
          }}
          data-testid={infoToolTipTestId}
        >
          <InfoIcon tabIndex={0} />
        </AurTooltip>
      );
    }
    return <InfoIcon />;
  };
  return (
    <Box
      aria-label={ariaLebel}
      className={`${styles.aurInfographicCell} ${className} aur-infographic-cell`}
    >
      <Box>
        <Box>
          <Typography
            tabIndex={0}
            className={`${styles.AurInfographicCellPrimaryText} aur-infographic-cell-primary-text`}
          >
            {primaryText}
          </Typography>
        </Box>
        <Box className={`${styles.AurInfographicCellSecondaryContainer}`}>
          <Typography
            tabIndex={0}
            className={`${styles.AurInfographicCellSecondaryText} aur-infographic-cell-secondary-text`}
          >
            {secondaryText}
          </Typography>
          {showInfoIcon && renderInfo()}
        </Box>
      </Box>
    </Box>
  );
};

export default AurInfographicCell;
